import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const DatabaseRetain = ({
  height = 16,
  width = 16,
  color = colors.grey80,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
    <g
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M7.625 10.6255C7.625 11.4211 7.94107 12.1842 8.50368 12.7468C9.06629 13.3094 9.82935 13.6255 10.625 13.6255C11.4206 13.6255 12.1837 13.3094 12.7463 12.7468C13.3089 12.1842 13.625 11.4211 13.625 10.6255C13.625 9.82984 13.3089 9.06678 12.7463 8.50417C12.1837 7.94156 11.4206 7.62549 10.625 7.62549C9.82935 7.62549 9.06629 7.94156 8.50368 8.50417C7.94107 9.06678 7.625 9.82984 7.625 10.6255V10.6255Z" />
      <path d="M11.951 10.6254H10.625V9.29944" />
      <path d="M11.8055 6.28199C12.924 5.87099 13.625 5.28199 13.625 4.62549C13.625 3.38249 11.1065 2.37549 8 2.37549C4.8935 2.37549 2.375 3.38249 2.375 4.62549C2.375 5.86849 4.8935 6.87549 8 6.87549" />
      <path d="M2.375 7.62549C2.375 8.61749 3.9805 9.45949 6.2085 9.75849" />
      <path d="M2.375 4.62549V10.6255C2.375 11.688 4.2165 12.5785 6.6925 12.814" />
      <path d="M13.625 7.27149V4.62549" />
      <path d="M11.8055 6.28199C12.924 5.87099 13.625 5.28199 13.625 4.62549C13.625 3.38249 11.1065 2.37549 8 2.37549C4.8935 2.37549 2.375 3.38249 2.375 4.62549C2.375 5.86849 4.8935 6.87549 8 6.87549" />
      <path d="M2.375 7.62549C2.375 8.61749 3.9805 9.45949 6.2085 9.75849" />
      <path d="M2.375 4.62549V10.6255C2.375 11.688 4.2165 12.5785 6.6925 12.814" />
      <path d="M13.625 7.27149V4.62549" />
    </g>
  </SvgIcon>
);
